/* eslint-disable import/prefer-default-export */
import fetch from 'isomorphic-fetch';
import config from '../../config';

// eslint-disable-next-line consistent-return
export default async (query) => {
  try {
    const request = await fetch(config.scienceDataURL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query }),
    });

    return await request.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};



// WEBPACK FOOTER //
// ./src/common/graphql/index.js